let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1GvQW")).then(() => parcelRequire('e6YbY'));